import React, { useState } from 'react';
import { Layout } from 'antd';
import menuItems from 'menu-items';
import { drawerWidth } from 'store/constant';
import Menu from './menu';
import LogoSection from '../LogoSection';
import { useStyles } from './index.style';

const { Sider } = Layout;

export interface IMenuItem {
  title: string;
  url: string;
  hidden?: boolean | null;
  include?: boolean | null;
  icon?: Function;
  fn?: Function;
  id?: string;
}

export interface IMenusList {
  title: string;
  url?: string;
  icon?: Function;
  fn?: Function;
  hidden?: boolean | null;
  items?: IMenuItem[];
  newcome?: boolean | null;
  id?: string;
}

const App: React.FC = () => {
  const { styles } = useStyles();
  const [collapsed, setCollapsed] = useState(false);

  return (
    <Sider
      collapsible={false}
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
      theme="light"
      width={drawerWidth}
      className={styles.container}
    >
      <div className={styles.wrap}>
        <LogoSection />
        <div className={styles.menuContainer}>
          {menuItems.items.map((x) => {
            return <Menu key={x.title} data={x} />;
          })}
        </div>
      </div>
    </Sider>
  );
};

export default App;
